import curadoraImg from '@/assets/curadora-new.webp'
import { useScrollAnimation } from '@/hooks/use-scroll-animation'

const CuratorSection = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-background via-muted/30 to-background">
      <div
        ref={ref}
        className={`container mx-auto max-w-6xl transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="bg-muted/30 backdrop-blur-sm rounded-2xl p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="order-2 md:order-1">
              <img
                src={curadoraImg}
                alt="Andrea Mayer - Curadora FotoLivro Store"
                className="rounded-2xl shadow-xl w-full h-[500px] object-cover object-top"
              />
            </div>
            <div className="order-1 md:order-2 space-y-3">
              <h2 className="font-serif text-4xl md:text-5xl font-bold">
                Conheça a{' '}
                <span className="font-serif text-4xl md:text-5xl text-gold italic">
                  Curadora
                </span>
              </h2>
              <h3 className="text-2xl font-semibold text-primary">
                Andrea Mayer
              </h3>
              <div className="font-sans text-muted-foreground leading-relaxed text-sm space-y-3">
                <p>
                  Fotógrafa profissional, construiu sua trajetória registrando
                  histórias reais, pessoas e momentos únicos.
                </p>
                <p>
                  Hoje, une experiência, sensibilidade e olhar apurado para
                  transformar fotografias pessoais em fotolivros sofisticados e
                  atemporais, feitos para preservar aquilo que o tempo não
                  deveria apagar.
                </p>
                <p>
                  Profunda conhecedora dos processos gráficos, edição de imagens
                  e design, acompanha cada etapa da criação com olhar técnico e
                  sensível, garantindo excelência em cada detalhe.
                </p>
                <p>
                  Apaixonada por arquitetura, viagens, design, arte e história,
                  entende que tudo na vida está interligado. É dessa visão que
                  nasce o seu trabalho: transformar fotografias pessoais em
                  fotolivros de extremo bom gosto, onde técnica, emoção e
                  narrativa se unem para preservar memórias que merecem
                  atravessar o tempo.
                </p>
                <p className="text-foreground font-medium pt-1">
                  Seja bem-vindo à Fotolivro Store.
                  <br />
                  Aqui ajudamos você a colocar sua história no mundo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CuratorSection
